import { GLServiceBase, ServiceRoute } from "commonui";
import { IAdminInterface, SignatureResoureModel } from ".";

class AdminServiceClass extends GLServiceBase<any, any> implements IAdminInterface {
	serviceRoute: ServiceRoute = { prefix: "content/v1/admin" };

	getUploadSasURL(): Promise<SignatureResoureModel[]> {
		return this.get("uploadsasurl");
	}

	getDownloadSasURL(): Promise<SignatureResoureModel[]> {
		return this.get("downloadsasurl");
	}
}

export const AdminService: IAdminInterface = new AdminServiceClass();
